import React from 'react';
import { Menu } from '@mantine/core';
import { Ellipsis } from 'lucide-react';
import { Button } from './Button';
import './DetailActionMenu.css';

export interface DetailActionMenuItem {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
  title?: string;
  danger?: boolean;
}

export interface DetailActionMenuProps {
  label: string;
  items: DetailActionMenuItem[];
}

export function DetailActionMenu({ label, items }: DetailActionMenuProps) {
  return (
    <Menu position="bottom-end" offset={6} width={260} shadow="md" radius="md" withinPortal withArrow returnFocus loop
      transitionProps={{ duration: 120 }}
      classNames={{ dropdown: 'ui-detail-action-menu', item: 'ui-detail-action-menu__item' }}
    >
      <Menu.Target>
        <Button size="sm" variant="secondary" aria-label={label}
          iconBefore={<Ellipsis size={18} aria-hidden="true" />}>
          More
        </Button>
      </Menu.Target>
      <Menu.Dropdown aria-label={label}>
        <div className="ui-detail-action-menu__items">
          {items.map((item) => (
            <React.Fragment key={item.label}>
              {item.danger ? <Menu.Divider /> : null}
              <Menu.Item leftSection={item.icon} onClick={item.onClick} disabled={item.disabled}
                title={item.title} color={item.danger ? 'var(--color-danger)' : undefined}>
                {item.label}
              </Menu.Item>
            </React.Fragment>
          ))}
        </div>
      </Menu.Dropdown>
    </Menu>
  );
}
